import React from "react";
import Page, { PageProps } from "../Page";
import { IPortalReportingPeriodPresenter } from "../../../presenter/portal/PortalReportingPeriodPresenter";
import DataGrid from "../../components/app/grid/DataGrid";
import ApplicantRowExpanded from "../../components/portal/ApplicantRowExpanded";
import ReportingPeriodDetails from "./ReportingPeriodDetails";
import { Divider, Typography } from "antd";
import Loader from "../../components/Loader";
import MobileReportingPeriodApplicantsTable from "./MobileReportingPeriodApplicantsTable";

export interface Props extends PageProps {}
export interface State extends IPortalReportingPeriodPresenter {}

export default class PortalReportingPeriodPage extends React.Component<
  Props,
  State
> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  render() {
    const {
      translate,
      applicants,
      onRowExpanded,
      reportingPeriod,
      forms,
      expandSpinnerEnabled,
      showFormDetails,
      onApplicantSelect,
      documents
    } = this.state;

    const { pageLoader } = this.state.loaders;

    const reportingPeriodsColumns = [
      {
        title: translate("portal.applicants.firstName"),
        dataIndex: "firstName",
        key: "firstName"
      },
      {
        title: translate("portal.applicants.lastName"),
        dataIndex: "lastName",
        key: "lastName"
      },
      {
        title: translate("portal.applicants.institutionName"),
        dataIndex: "institutionName",
        key: "institutionName"
      },
      {
        title: translate("portal.applicants.positionType"),
        dataIndex: "positionTypeName",
        key: "positionTypeName"
      }
    ];

    const expandedRowRender = (e) => {
      return (
        <ApplicantRowExpanded
          showFormDetails={showFormDetails}
          translate={translate}
          forms={forms}
          spinnerEnabled={expandSpinnerEnabled}
          documents={documents || []}
        />
      );
    };

    return (
      <Page {...this.props}>
        <Loader translate={translate} loading={pageLoader || false}>
          <Typography.Title
            className={"portal-reporting-period-title"}
            type={"secondary"}
            style={{ fontSize: 18 }}
          >
            {reportingPeriod.name}
          </Typography.Title>
          <Divider
            type={"horizontal"}
            style={{ marginTop: 10, marginBottom: 10 }}
          />
          <ReportingPeriodDetails
            className={"reporting-period-details"}
            translate={translate}
            reportingPeriod={reportingPeriod}
          />
          <Divider
            type={"horizontal"}
            style={{ marginTop: 10, marginBottom: 10 }}
          />
          <div className={"portal-period-applicants-table"}>
            <DataGrid
              translate={translate}
              columns={reportingPeriodsColumns}
              dataSource={applicants}
              expandedRowRender={expandedRowRender}
              onExpand={onRowExpanded}
              singleRowExpandEnabled={true}
            />
          </div>
          <MobileReportingPeriodApplicantsTable
            className={"mobile-portal-period-applicants-table"}
            translate={translate}
            columns={reportingPeriodsColumns}
            applicants={applicants}
            selectedApplicantForms={forms}
            onApplicantSelect={onApplicantSelect}
            showFormDetails={showFormDetails}
            documents={documents}
          />
        </Loader>
      </Page>
    );
  }
}
